module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.qrCodeLoading),
      expression: "qrCodeLoading"
    }],
    staticClass: "qr-code"
  }, [(_vm.qrCodeUrl) ? _c('img', {
    staticClass: "img",
    attrs: {
      "src": _vm.qrCodeUrl,
      "alt": "扫描二维码"
    }
  }) : _c('div', {
    staticClass: "img"
  }), _vm._v(" "), _c('p', {
    staticClass: "qr-code-tips"
  }, [_vm._v("请使用微信扫描图中二维码")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-5ad83a4f!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/validation/other/bind_wechat.vue
// module id = DvTm
// module chunks = 16